// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Server } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconServer(props: any) {
    return <IconBase icon={Server} {...props} />
  }

  export default IconServer
  